<template>
  <div>
    <div class="h4 mb-4">{{ $t('checkout.organizer') }}</div>
    <div class="grid grid-cols-2 gap-1">
      <div>{{ customer.alias }}</div>
      <div>{{ customer.address }}</div>
      <div>CVR: {{ customer.vat }}</div>
      <div>{{ customer.zip + ' ' + customer.city }}</div>
    </div>

    <div class="border-t border-surface-grey mt-10 pt-10">
      <div class="h4 mb-4">
        {{ $t('checkout.order_information') }}
      </div>
      <div class="grid grid-cols-2 gap-6">
        <div>
          <div class="text-sm text-text">
            {{ $t('checkout.order_number') }}:
          </div>
          <div>{{ cart.receiptOrder.orderid }}</div>
        </div>

        <div v-if="orderTime">
          <div class="text-sm text-text">{{ $t('checkout.order_time') }}:</div>
          <div>{{ orderTime }}</div>
        </div>

        <div v-if="cart.ReceiptConfirmPayment.transaction">
          <div class="text-sm text-text">
            {{ $t('checkout.transaction_id') }}:
          </div>
          <div>{{ cart.ReceiptConfirmPayment.transaction }}</div>
        </div>

        <div v-if="cart.ReceiptConfirmPayment.cardnumber">
          <div class="text-sm text-text">{{ $t('checkout.card_number') }}:</div>
          <div>{{ cart.ReceiptConfirmPayment.cardnumber.replace(/X/g, '*').replace(/(\*{4})/g, '**** ') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { useCartStore } from '@/stores/cart';
  import { useGeneralStore } from '@/stores/general';
  import type {  Customer} from '@/types';
  import { formatDateWithOffset } from '@/utils/formatDate';

  const cart = useCartStore();
  const generalStore = useGeneralStore();
  const { locale } = useI18n();

  const customer = computed(() => generalStore.customer() as Customer);
  const orderTime = computed(() => formatDateWithOffset(
    cart.ReceiptConfirmPayment.ts,
    cart.ReceiptConfirmPayment.ts_gmt_offset,
    { locale: locale.value, showTime: true },
  ));

</script>
